<template>
  <div>
    <div>
      <tabbar title="作品详情" hasBack></tabbar>
    </div>
    <div v-if="active == 1" class="video">
      <!-- <video :src="apiUrl + data.video" webkit-playsinline="true" playsinline="true" id="videoPlay" controls>
            </video> -->
      <!-- 使用组件 -->
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
      </video-player>
    </div>
    <div v-else-if="active === 2">
      <van-swipe class="my-swipe" :autoplay="3000" @change="onChange">
        <van-swipe-item v-for="(item, index) in data.ppt_imgs" :key="index">
          <img style="width: 3.75rem;" :src="apiUrl + item" alt="">
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            {{ current + 1 }}/{{data.ppt_imgs.length}}
          </div>
        </template>
      </van-swipe>
    </div>
    <div v-else>
      <pdf :pdfSrc="data.teach_img"></pdf>
    </div>

    <div class="xuanxiang">
      <div>
        <span @click="dianji(1)" class="span" :class="active == 1 ? 'active_type':'' ">微课视频</span>
        <span @click="dianji(2)" class="span" :class="active == 2 ? 'active_type':'' ">PPT资源</span>
        <span @click="dianji(3)" class="span" :class="active == 3 ? 'active_type':'' ">教案文档</span>
      </div>
    </div>
    <div class="content">
      <h2>{{data.title}}</h2>
      <div style="margin-top: 0.2rem;">
        <span class="bianhao">作品编号：A{{data.number}}</span>
        <span style="float: right;font-size: 0.12rem;margin: 0.04rem 0;">得票数：<b
            style="font-size: 0.15rem;">{{data.praise}}票</b></span>
      </div>
      <h3>作品简介：</h3>
      <p>
        {{data.message}}
      </p>
    </div>

    <div class="footer">
      <button v-if="is_praise == 0" @click="praise" class="weidian">为他点赞</button>
      <button else class="yidian">已点赞</button>
    </div>
  </div>
</template>
<script>
  import tabbar from '@/components/common/tabbar';
  import * as util from "@/utils/network";
  import Vue from 'vue';
  import { Swipe, SwipeItem } from 'vant';
  import { Toast } from "vant";
  // 导入组件
  import { videoPlayer } from 'vue-video-player'
  import 'videojs-flash'
  import pdf from '@/components/common/pdf';
  export default {
    // name: 'VideoPlayer',
    data() {
      return {
        current: 0,
        data: [],
        active: 1,
        is_praise: 0,
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 如果为true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 是否视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "video/mp4", // 类型
            src: '' // url地址
          }],
          poster: '', // 封面地址
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: true, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            fullscreenToggle: true // 是否显示全屏按钮
          }
        }
      }
    },
    components: {
      tabbar,
      pdf,
      videoPlayer
    },
    created: function () {
      var query = this.$route.query
      let id = query.id ? query.id : '';
      // if (this.commonApi.getCookie(id)) {
      //   this.is_praise = 1
      // }
      if (localStorage.getItem(id)) {
        this.is_praise = 1
      }
      if (localStorage.getItem('time') < (new Date().getTime())) {
        window.localStorage.clear()
      }
      this.getCourse(); //需要触发的函数
      // document.getElementById('videoPlay').controlsList = "nodownload";
    },
    methods: {
      onChange(index) {
        this.current = index;
      },
      praise() {
        var query = this.$route.query
        let id = query.id ? query.id : '';
        let that = this;
        // var is_praise = that.commonApi.getCookie(id);
        // if (is_praise) {
        //   Toast('此作品已投过票');
        //   return false;
        // }
        // let num = (that.commonApi.getCookie('num')) ? parseInt(that.commonApi.getCookie('num')) : 0;

        var is_praise = localStorage.getItem(id);
        if (is_praise) {
          Toast('此作品已投过票');
          return false;
        }

        let num = (localStorage.getItem('num')) ? parseInt(localStorage.getItem('num')) : 0;

        if (num >= 3) {
          Toast('只允许投三票');
          return false;
        }
        //发送请求
        util.get('/course/praise', {
          id: id
        },
          function (result) {
            // that.commonApi.setCookie(id, 1, 1);
            // that.commonApi.setCookie('num', num + 1, 1);
            localStorage.setItem(id, 1);
            localStorage.setItem('num', num + 1);
            localStorage.setItem('time', (new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).getTime());
            that.is_praise = 1
            that.data.praise += 1;
            Toast(result.msg);
          }
        )
      },
      getCourse: function () {
        let that = this;
        var query = this.$route.query
        let id = query.id ? query.id : '';
        if (!id) {
          Toast('参数错误');
          return false;
        }
        util.post('/course/courseInfo', {
          id: id
        },
          function (result) {
            that.data = result.data;
            that.playerOptions['sources'][0]['src'] = that.apiUrl + result.data.video
            that.playerOptions['poster'] = that.apiUrl + result.data.cover_img
          }
        )
      },
      // playVideo() {
      //     // var vdo = document.getElementById("videoPlay");
      //     var vdo = document.getElementsByClassName("vjs-big-play-button");
      //     if (vdo.paused) {
      //         //点击视频的时候如果暂停状态，则让其播放
      //         vdo.play();
      //     } else {
      //         vdo.pause();
      //     }
      // },
      dianji(a) {
        this.active = a
      }
    }

  }
</script>
<style scoped>
  .dingbu {
    height: 2rem;
  }

  .video video {
    width: 3.75rem;
  }

  .xuanxiang {
    margin-top: 0.13rem;
    margin-bottom: 0.28rem;
  }

  .xuanxiang>div {
    overflow: hidden;
    margin: 0 auto;
    width: 2.3rem;
  }

  .span {
    width: 0.74rem;
    height: 0.35rem;
    float: left;
    border: 0.01rem solid #127CD6;
    display: block;
    font-size: 0.13rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #202020;
    text-align: center;
    line-height: 0.35rem;
  }

  .active_type {
    background: #127CD6;
    border-radius: 0rem 0rem 0rem 0rem;
    color: #fff;
  }

  .content {
    margin: 0 0.18rem;
  }

  .content h2 {
    font-size: 0.18rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 0.24rem;
  }

  .content h3 {
    font-size: 0.14rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-top: 0.24rem;
  }

  .content p {
    margin-top: 0.17rem;
    font-size: 0.14rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #545454;
    line-height: 0.34rem;
    margin-bottom: 0.9rem;
  }

  .bianhao {
    font-size: 0.11rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #9B9B9B;
    display: inline-block;
    background: #EFEFEF;
    border-radius: 0rem;
    padding: 0.05rem;
  }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    /* line-height: 150px; */
    text-align: center;
    /* background-color: #39a9ed; */
  }

  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
  }

  .footer {
    width: 3.75rem;
    height: 0.62rem;
    background: #FFFFFF;
    box-shadow: 0rem 0rem 0rem 0rem rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    text-align: center;
  }

  .footer button {
    width: 2.56rem;
    height: 0.42rem;
    border-radius: 0rem;
    margin: 0.1rem;
    border: none;
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }

  .weidian {
    background: #127CD6;
  }

  .yidian {
    background: grey;
  }
</style>


// WEBPACK FOOTER //
// src/components/course.vue